
import {queryPayLog} from "@/api/http";

let columnList: Array<column> = [
    {
        prop: "store_name",
        label: "门店名称",
        width: 145,
    },
    {
        prop: "order_sn",
        label: "订单编号",
        width: 105,
    },
    {
        prop: "payStatus",
        label: "是否支付",
        width: 68,
    },
    {
        prop: "user_id",
        label: "用户id",
        width: 68,
    },
    {
        prop: "pay_time_text",
        label: "支付时间",
        width: 105,
    },
    {
        prop: "pay_type_text",
        label: "支付方式",
        width: 85,
    },
    {
        prop: "income_type",
        label: "收入类型",
        width: 68,
    },
    {
        prop: "payment",
        label: "收入金额（元）",
        width: 68,
    },
    // {
    //     prop: "split_office",
    //     label: "门店收入（元）",
    //     width: 68,
    // },
    // {
    //     prop: "head_office",
    //     label: "平台抽成（元）",
    //     width: 68,
    // },

    {
        prop: "payment_account",
        label: "收款卡号",
        width: 108,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted
} from "vue";
import {dateformat, getFirstNowLastDay} from "@/api/date" ;
import {Request} from '@/api/request';
import { column } from "@/assets/types/common";
export default defineComponent({
    name: "Paybills",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['支付流水']);
   
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            total_price = ref(0),
            userinfo = ref(false),
            selectList = ref({
                Framework:[]
            } as any),
            head_office_price = ref(0),
            split_office_price = ref(0),
            loading = ref(false),
            params = reactive({
                status:1,
                time: [getFirstNowLastDay()[0],getFirstNowLastDay()[1]],
                start_time: null,
                end_time: null,
                store_id:-1
        });
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getSummaries = (param: any): Array<string> => {
                const {columns, data} = param;
                const sums: any = [];
                const propArr = [
                    "payment",
                    "head_office",
                    "split_office"
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        if (column.property == "payment") {
                            sums[index] = total_price.value;
                        }
                        if (column.property == "head_office") {
                            sums[index] = head_office_price.value;
                        }
                        if (column.property == "split_office") {
                            sums[index] = split_office_price.value;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            queryData = (ordersn:any)=>{
                queryPayLog({ordersn:ordersn}).then((res:any)=>{
                    if (res.status == 202){
                        currentPage.value = 1;
                        getTableData();
                    }
                });
            },
            screenChange = (e: string | Array < any > , key: any): void => {
                currentPage.value = 1;
                getTableData();
            },
        getTableData = (): void => {
            let start_time = params.time?Math.floor(new Date(params.time[0]).getTime()/1000):"";
            let end_time = params.time ?Math.floor((new Date(params.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                loading.value = true;
                Request.axiosInstance({
                    url: 'adminapi/Payment/payFlowList',
                    data: {
                        page: currentPage.value,
                        pageSize: pageSize.value,
                        ...params,
                        start_time:start_time,
                        end_time:end_time
                    }
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    total_price.value = res?.content?.total_price || 0;
                    head_office_price.value = res?.content?.head_office || 0;
                    split_office_price.value = res?.content?.split_office || 0;
                })

            }
        onMounted(async() => {
            
            getTableData();
            await Request.axiosInstance({
                url: 'adminapi/Framework/totalList'
            }).then((res: any) => {
                selectList.value.Framework = [{id:-1,store_name:"请选择"},...res?.content?.list];
            })
            let info;
            let user_info = localStorage.getItem('user_info');
            if (user_info) {
                info = JSON.parse(user_info);
                if (info.store_id==0){
                    userinfo.value = true;
                }
            }

        });
        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            userinfo,
            tableData,
            handleSizeChange,
            handleCurrentChange,
            total,
            loading,
            getSummaries,
            total_price,
            head_office_price,
            split_office_price,
            params,
            screenChange,
            selectList,
            queryData
        };
    },
});
